import React from 'react';
import Icon from '../../../components/AppIcon';

const benefits = [
  {
    icon: 'ScanLine',
    title: 'Automatic Purchase Tracking',
    description: 'Every purchase made with your SocialCents Card registers instantly — no manual submission needed.',
    color: '#14B8A6',
    bg: 'rgba(20, 184, 166, 0.08)',
    border: 'rgba(20, 184, 166, 0.2)',
    span: 'lg:col-span-2'
  },
  {
    icon: 'Zap',
    title: 'Instant Cashback Rewards',
    description: 'Eligible purchases generate cashback based on your SocialCents Score — higher score, higher returns.',
    color: '#F59E0B',
    bg: 'rgba(245, 158, 11, 0.08)',
    border: 'rgba(245, 158, 11, 0.2)',
    span: 'lg:col-span-1'
  },
  {
    icon: 'Users',
    title: 'Creator-first Financial Tools',
    description: 'Built specifically for creators and influencers — not a generic card, but a platform-native financial product.',
    color: '#3B82F6',
    bg: 'rgba(59, 130, 246, 0.08)',
    border: 'rgba(59, 130, 246, 0.2)',
    span: 'lg:col-span-1'
  },
  {
    icon: 'Gift',
    title: 'Exclusive Brand Benefits',
    description: 'Access special promotions, early campaign access, and partner brand rewards unavailable to standard users.',
    color: '#10B981',
    bg: 'rgba(16, 185, 129, 0.08)',
    border: 'rgba(16, 185, 129, 0.2)',
    span: 'lg:col-span-2'
  }
];

const CardBenefits = () => {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold text-foreground">Card Benefits</h2>
        <p className="text-muted-foreground text-sm mt-1">What the SocialCents Card will unlock for you</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {benefits?.map((benefit, i) => (
          <div
            key={i}
            className={`${benefit?.span} group rounded-2xl p-5 transition-all duration-300 cursor-default`}
            style={{
              background: benefit?.bg,
              border: `1px solid ${benefit?.border}`,
            }}
          >
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110"
              style={{ background: `${benefit?.color}20`, border: `1px solid ${benefit?.color}30` }}
            >
              <Icon name={benefit?.icon} size={18} style={{ color: benefit?.color }} />
            </div>
            <h3 className="text-base font-semibold text-foreground mb-2">{benefit?.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{benefit?.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardBenefits;
